(() => {
  const sourceSelector = '.vcf-price-widget';
  const outputSelector = '.boxy-preorder-dispatch';
  let syncQueued = false;

  const formatDispatchMessage = (sourceText) => {
    const dateMatch = sourceText.match(/ships\s+on\s+([a-z]+)\s+(\d{1,2}),\s+(\d{4})/i);

    if (dateMatch) {
      const [, month, day, year] = dateMatch;
      const formattedMonth = `${month.charAt(0).toUpperCase()}${month.slice(1).toLowerCase()}`;
      return `Estimated dispatch on ${Number(day)} ${formattedMonth} ${year}`;
    }

    const fallbackDate = sourceText.match(/ships\s+on\s+(.+?)(?:\.\s*$|$)/i);
    if (fallbackDate) {
      return `Estimated dispatch on ${fallbackDate[1].trim()}`;
    }

    return 'Available for pre-order';
  };

  const findPurchaseContext = (source) =>
    source.closest('form') ||
    source.closest('.boxy-product-landing__purchase') ||
    source.closest('.product-details') ||
    source.parentElement;

  const findPurchaseButton = (context) =>
    context?.querySelector(
      '[data-add-button], .vcf-pre-order, add-to-cart-component button[type="submit"], button[name="add"], button[type="submit"]'
    );

  const findInsertionAnchor = (source, button) => {
    let anchor = button.closest('add-to-cart-component') || button;

    if (anchor.parentElement === source.parentElement && source.parentElement?.tagName === 'SPAN') {
      anchor = source.parentElement;
    }

    return anchor;
  };

  const syncPreorderMessages = () => {
    const existingOutputs = document.querySelectorAll(outputSelector);
    existingOutputs.forEach((output) => {
      output.dataset.boxyPreorderActive = 'false';
    });

    document.querySelectorAll('[data-boxy-preorder-status-hidden]').forEach((status) => {
      status.hidden = false;
      status.removeAttribute('data-boxy-preorder-status-hidden');
    });

    document.querySelectorAll(sourceSelector).forEach((source) => {
      const context = findPurchaseContext(source);
      const button = findPurchaseButton(context);
      if (!button) return;

      source.setAttribute('aria-hidden', 'true');

      const anchor = findInsertionAnchor(source, button);
      let output = anchor.nextElementSibling;

      if (!output?.matches(outputSelector)) {
        output = document.createElement('p');
        output.className = outputSelector.slice(1);
        output.setAttribute('role', 'status');
        output.setAttribute('aria-live', 'polite');
        anchor.insertAdjacentElement('afterend', output);
      }

      const message = formatDispatchMessage(source.textContent || '');
      if (output.textContent !== message) {
        output.textContent = message;
      }

      output.hidden = false;
      output.dataset.boxyPreorderActive = 'true';

      const status = context.querySelector?.('[data-variant-status]');
      if (status && /pre-?order/i.test(status.textContent || '')) {
        status.hidden = true;
        status.dataset.boxyPreorderStatusHidden = 'true';
      }
    });

    existingOutputs.forEach((output) => {
      if (output.dataset.boxyPreorderActive === 'false') {
        output.remove();
      }
    });
  };

  const scheduleSync = () => {
    if (syncQueued) return;
    syncQueued = true;

    window.requestAnimationFrame(() => {
      syncQueued = false;
      syncPreorderMessages();
    });
  };

  const includesPreorderWidget = (node) =>
    node instanceof Element && (node.matches(sourceSelector) || node.querySelector(sourceSelector));

  const observer = new MutationObserver((mutations) => {
    const shouldSync = mutations.some((mutation) => {
      const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
      if (target?.closest(sourceSelector)) return true;

      return [...mutation.addedNodes, ...mutation.removedNodes].some(includesPreorderWidget);
    });

    if (shouldSync) scheduleSync();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();
